import React, { useEffect, useState } from 'react'
import Loader from '../Loader'
import BottomFooter from '../BottomFooter'
import { useNavigate } from 'react-router-dom'
import { postApiAdmin } from '../../service'
import { useDispatch, useSelector } from 'react-redux'
import { ADMIN_API } from '../../common/common'
import { Logout } from '../../common/Funcation'
import moment from 'moment'
import { styleObjectGetBG } from '../../common/StyleSeter'

function BalanceOverview() {
    const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
    const [didLoad, setDidLoad] = useState<boolean>(false);
    const [isLoadingMain, setIsLoadingMain] = useState(false)
    const [pageData, setPageData] = useState<any>({})
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const userData = useSelector((e: any) => e.userData);

    const HeaderData = useSelector((e: any) => e.Header);

    const userId = HeaderData?._id

    const DD = useSelector((e: any) => e.domainDetails);

    useEffect(() => {
        //'/admin/downLineList'
        if (!didLoad) {
            if (isAuthenticated?.isLogin) {
                getPageData(isAuthenticated.token)
            }
            setDidLoad(true);
        }
        return () => {

        }
    }, [didLoad, isAuthenticated])


    const getPageData = async (FROM: string = '', TO: string = '', FILTER: any = { reportType: '', report: '' }, PAGE: string = '1',) => {
        setIsLoadingMain(true)
        let data: any = {
            api: ADMIN_API.MY_ACCOUNT.GET_STATEMENTS,
            value: {
                id: userId ? userId : userData?._id,
                page: PAGE ? PAGE : '1',
                limit: '10'
            },
        }
        //reportType
        //report

        if (TO !== '') { data.value.to = TO }
        if (FROM !== '') { data.value.from = FROM }
        if (FILTER.reportType !== '') {
            data.value.type = FILTER.reportType
        }

        await postApiAdmin(data).then(function (response) {
            // console.log("PageDATA::: ", response);
            setPageData(response.data.data)
            setIsLoadingMain(false)

        }).catch(err => {

            if (err.response.data.statusCode === 401) {
                setIsLoadingMain(false)
                Logout()
                navigate('/login')
            }
        })
    }



    return (
        <>
            <div className='full-wrap bottomfooter leagues'>
                {isLoadingMain && <Loader />}
                <style>{`
                    .paddingZero {
                    padding-left: 0px !important;
                    }
                `}</style>
                <div className="paddingZero balance-label position-relative" style={{ fontSize: "14.56px", fontWeight: 400 }} >
                    {/* <button className="bg-transparent border-0 text-white position-absolute start-0 pt-0" onClick={() => navigate('/')}>
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 512" className="fs-3" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
                        </svg>
                    </button> */}
                    Balance Overview
                    <div className='cross-icon' onClick={() => navigate('/')} />
                </div>

                <div className="inner-sidebar-content" style={{ padding: "1rem" }}>
                    <div className="balance-sec px-3 pt-3 pb-2 mb-3">
                        <h5 style={{ fontSize: "14.56px", marginBottom: 0 }}>Your Balances</h5>
                        <h6 className="fs-4"> <span style={{ ...styleObjectGetBG(DD?.colorSchema), fontSize: "10.4px", padding: "0.125rem .375rem" }}>PBU</span> {HeaderData.balance} </h6>
                    </div>



                    <div className='balance-deposit-sec mt-3'>
                        {pageData.userStatement && pageData.userStatement?.results?.length > 0 ? pageData.userStatement.results.map((item: any, i: any) => {
                            return (
                                <table key={i} className="rounded overflow-hidden bg-white table table-bordered" style={{ marginBottom: "0.5rem" }}>
                                    <thead>
                                        <tr>
                                            <th colSpan={4} style={{ fontSize: "12.48px", fontWeight: 400, padding: "0.25rem 1rem" }}>{moment(item.createdAt).format('YYYY-MM-DD hh:mm:ss')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr style={{ borderLeftWidth: "0px", borderRightWidth: "0px" }}>
                                            <td width="33.3%" style={{ fontSize: '10.4px', fontWeight: 400, borderLeftWidth: "0px" }}>
                                                Deposit
                                                <strong className={`d-block`} style={{ fontSize: "14.56px", fontWeight: 700 }}>{item.credit > 0 ? item.credit : "--"}</strong>
                                            </td>

                                            <td width="33.3%" style={{ fontSize: '10.4px', fontWeight: 400, borderLeftWidth: "0px", borderRightWidth: "0px" }}>
                                                Withdraw
                                                <strong className="d-block text-danger" style={{ fontSize: "14.56px", fontWeight: 700 }}>{item.debit > 0 ? item.debit : "--"}</strong>
                                            </td>
                                            <td width="33.3%" style={{ fontSize: '10.4px', fontWeight: 400, borderRightWidth: "0px" }}>
                                                Balance
                                                <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700 }}>{item.balance}</strong>
                                            </td>
                                        </tr>

                                        <tr style={{ borderLeftWidth: "0px", borderRightWidth: "0px" }}>
                                            <td width="50%" colSpan={4} style={{ display: "flex", justifyContent: "start", alignItems: "center", width: "100%", border: "none", gap: "8px", fontSize: "12.48px" }}>{item.from?.user_name ?? "-"}
                                                <div style={{ width: 0, height: 0, borderStyle: "solid", borderWidth: "5px 0 5px 8px", borderColor: "#0000 #0000 #0000 #9cb1bd" }} />

                                                {item.to?.user_name ?? "-"}</td>
                                        </tr>
                                        <tr style={{ border: "none" }}>
                                            <td width="100%" colSpan={4} style={{ border: "none" }}>
                                                <span>Remark</span>
                                                <span style={{ fontSize: "12px", fontWeight: 700, marginLeft: "1.5rem", color: "#6F8898" }}>{item.Remark ?? "-"}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        }) : <h2>No Record</h2>}

                    </div>


                </div>

            </div>
        </>


    )
}

export default BalanceOverview